import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import propTypes from 'prop-types'
import map from 'lodash/map'
import { Log } from './Logs'

class RevisionDiffModal extends Component {
  static propTypes = {
    logStore: propTypes.object,
    modalStore: propTypes.object,
    log: propTypes.object.isRequired
  }
  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    wideContent: true
  }

  constructor (props) {
    super(props)

    this.state = {
      error: null
    }

    props.logStore.getDiff(props.log.revision_hash)
  }

  handleExit = () => {
    this.props.modalStore.close()
  }

  render () {
    return (
      <div>
        <h4>
          <Log log={this.props.log} noDetails />
        </h4>
        {!this.props.logStore.diffTables.length && <div>No data found</div>}
        {this.props.logStore.diffTables.map(table => (
          <div>
            <h4>{table.name}</h4>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '50%', overflowX: 'auto' }}>
                <DiffTable data={table.old} caption='old' />
              </div>
              <div style={{ width: '50%', overflowX: 'auto' }}>
                <DiffTable data={table.new} caption='new' />
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

const DiffTable = ({ data, caption }) => {
  return (
    <table className='table-wrapper--nested'>
      <thead>
        <tr>
          <th colSpan={2}>{caption}</th>
        </tr>
      </thead>
      <tbody>
        {map(data, (value, key) => (
          <tr>
            <td>{key}</td>
            <td>{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

DiffTable.propTypes = {
  data: propTypes.object.isRequired,
  caption: propTypes.string.isRequired
}

export default inject('logStore', 'modalStore')(observer(RevisionDiffModal))
